import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Image from '../Image';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * A container for background image
 */

export default function BackgroundImageContainer({
  className,
  backgroundClassName,
  src,
  imageProps,
  children,
}) {
  return (
    <div className={cx('backgroundContainer', className)}>
      {src && (
        <div className={cx('background', backgroundClassName)}>
          <Image
            src={src}
            {...imageProps}
            className={cx(
              'backgroundImage',
              (imageProps || {}).className ? imageProps.className : null,
            )}
          />
        </div>
      )}
      <div className={cx('content')}>{children}</div>
    </div>
  );
}

BackgroundImageContainer.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
  backgroundClassName: PropTypes.string,
  children: PropTypes.any,
  /* object for tunneling specific props to image, if it needed - alt, etc. */
  imageProps: PropTypes.object,
};
